import React, { FC, useState } from 'react';
import { useToggle } from 'react-use';
import { Icon } from '@app/components/Icon';
import { Button } from '@chakra-ui/react';
import { Position } from '@cryptoalgebra/kim-sdk';
import { TransactionResultModal } from '@app/components/TransactionResultModal';
import { useRouter } from 'next/router';
import { BurnLiquidityModalV3Content } from '@app/screens/positions/components/BurnLiquidityModalV3/BurnLiquidityModalV3Content';

interface Props {
  fullWidth?: boolean;
  position: Position;
  positionId: number;
}

export const BurnLiquidityModalV3: FC<Props> = ({
  fullWidth,
  position,
  positionId
}) => {
  const router = useRouter();
  const [feedback, setFeedback] = useState<{
    status: 'success' | 'error';
    title: string;
    message: string;
    txHash?: string;
  } | null>(null);
  const [open, toggleOpen] = useToggle(false);

  return (
    <>
      <Button
        width={fullWidth ? '100%' : ['100%', 'fit-content']}
        leftIcon={
          <Icon name="trash" style={{ width: '18px', height: '18px' }} />
        }
        variant="rowCompact"
        onClick={toggleOpen}
      >
        Burn
      </Button>
      {open && (
        <BurnLiquidityModalV3Content
          onClose={(txHash?: string) => {
            if (txHash) {
              setFeedback({
                status: 'success',
                title: 'Transaction Confirmed',
                message: 'Your transaction has been successfully completed',
                txHash
              });
            } else {
              toggleOpen(false);
            }
          }}
          isOpen={open}
          position={position}
          positionId={positionId}
        />
      )}
      <TransactionResultModal
        isOpen={!!feedback}
        status={feedback?.status}
        title={feedback?.title}
        message={feedback?.message}
        txHash={feedback?.txHash}
        onClose={() => {
          setFeedback(null);
          router.reload();
        }}
      />
    </>
  );
};
